import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Dictionary } from '@/src/lib/dictionary/types.ts';
import { getFormattedPriceWithLocaleCurrency } from '@/src/lib/product/business/product-prices.ts';
import Loading from '@/src/app/components/LoadingSpinner/LoadingSpinner.tsx';
import { YourPriceResponseWithCurrency } from '@/src/lib/your-price/types.ts';
type PriceInfoModalContentProps = {
  dict: Dictionary;
  lang: string;
  currencyIsoCode: string;
  yourPriceData: YourPriceResponseWithCurrency | null;
  isLoading: boolean;
  error: Error | null;
  priceGroup?: string | null;
  productListPrice?: number;
};
function PriceInfoModalContent(t0) {
  const $ = _c(48);
  const {
    dict,
    error,
    isLoading,
    lang,
    currencyIsoCode,
    yourPriceData,
    priceGroup,
    productListPrice
  } = t0;
  const netPrice = yourPriceData?.items[0].netPrice || 0;
  let t1;
  if ($[0] !== dict.product.yourPrice) {
    t1 = <h1 className="display-title-3xl">{dict.product.yourPrice}</h1>;
    $[0] = dict.product.yourPrice;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== dict.product.priceInfoModalDescription) {
    t2 = <p className="text-base text-gray-500 mt-2 ">{dict.product.priceInfoModalDescription}</p>;
    $[2] = dict.product.priceInfoModalDescription;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== dict.product.priceDetails) {
    t3 = <thead><tr><th colSpan={2} scope="table" className="bg-gray-200 font-semibold py-3 px-3">{dict.product.priceDetails}</th></tr></thead>;
    $[4] = dict.product.priceDetails;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== dict.product.priceGroup || $[7] !== priceGroup) {
    t4 = priceGroup ? <tr><th className="font-normal py-3 px-3" scope="row">{dict.product.priceGroup}</th><td className="text-right py-3 px-3">{priceGroup}</td></tr> : null;
    $[6] = dict.product.priceGroup;
    $[7] = priceGroup;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== currencyIsoCode || $[10] !== dict.product.listPrice || $[11] !== lang || $[12] !== productListPrice) {
    t5 = productListPrice ? <tr><th className="font-normal py-3 px-3" scope="row">{dict.product.listPrice}</th><td className="text-right py-3 px-3">{getFormattedPriceWithLocaleCurrency(productListPrice, currencyIsoCode, lang)}</td></tr> : null;
    $[9] = currencyIsoCode;
    $[10] = dict.product.listPrice;
    $[11] = lang;
    $[12] = productListPrice;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== dict.product.discount || $[15] !== yourPriceData?.items[0].discount) {
    t6 = yourPriceData?.items[0].discount ? <tr><th className="font-normal py-3 px-3" scope="row">{dict.product.discount}</th><td className="text-right py-3 px-3">{yourPriceData?.items[0].discount} %</td></tr> : null;
    $[14] = dict.product.discount;
    $[15] = yourPriceData?.items[0].discount;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== currencyIsoCode || $[18] !== dict.product.surcharge || $[19] !== lang || $[20] !== yourPriceData?.items[0].surcharge) {
    t7 = yourPriceData?.items[0].surcharge ? <tr><th className="font-normal py-3 px-3" scope="row">{dict.product.surcharge}</th><td className="text-right py-3 px-3">{getFormattedPriceWithLocaleCurrency(yourPriceData?.items[0].surcharge / 100, currencyIsoCode, lang)}</td></tr> : null;
    $[17] = currencyIsoCode;
    $[18] = dict.product.surcharge;
    $[19] = lang;
    $[20] = yourPriceData?.items[0].surcharge;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== dict.product.yourPrice) {
    t8 = <th className="font-semibold py-3 px-3" scope="row">{dict.product.yourPrice}</th>;
    $[22] = dict.product.yourPrice;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== currencyIsoCode || $[25] !== error || $[26] !== isLoading || $[27] !== lang || $[28] !== netPrice) {
    t9 = isLoading ? <div className="flex flex-row justify-end"><Loading small={true} className="inline-block" /></div> : !netPrice && error ? <span className="text-danger">{error.toString()}</span> : getFormattedPriceWithLocaleCurrency(netPrice, currencyIsoCode, lang);
    $[24] = currencyIsoCode;
    $[25] = error;
    $[26] = isLoading;
    $[27] = lang;
    $[28] = netPrice;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== t9) {
    t10 = <td className="text-right font-semibold py-3 px-3">{t9}</td>;
    $[30] = t9;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  let t11;
  if ($[32] !== t10 || $[33] !== t8) {
    t11 = <tr>{t8}{t10}</tr>;
    $[32] = t10;
    $[33] = t8;
    $[34] = t11;
  } else {
    t11 = $[34];
  }
  let t12;
  if ($[35] !== t11 || $[36] !== t4 || $[37] !== t5 || $[38] !== t6 || $[39] !== t7) {
    t12 = <tbody className="divide-y divide-gray-200">{t4}{t5}{t6}{t7}{t11}</tbody>;
    $[35] = t11;
    $[36] = t4;
    $[37] = t5;
    $[38] = t6;
    $[39] = t7;
    $[40] = t12;
  } else {
    t12 = $[40];
  }
  let t13;
  if ($[41] !== t12 || $[42] !== t3) {
    t13 = <table className="min-w-full border-b border-gray-300 mt-8">{t3}{t12}</table>;
    $[41] = t12;
    $[42] = t3;
    $[43] = t13;
  } else {
    t13 = $[43];
  }
  let t14;
  if ($[44] !== t1 || $[45] !== t13 || $[46] !== t2) {
    t14 = <div>{t1}{t2}{t13}</div>;
    $[44] = t1;
    $[45] = t13;
    $[46] = t2;
    $[47] = t14;
  } else {
    t14 = $[47];
  }
  return t14;
}
export default PriceInfoModalContent;